/**
 * One Bootstrap icon per support the group can call, so a support reads before its name does on the
 * briefing. The game's own picture of a support comes from the class the platform sends in the
 * session view's `supports` (`SupportPicture`); the icon stands where there is none, or where the
 * panel cannot answer for it.
 */
export const SUPPORT_ICONS: Record<string, string> = {
  artillery: 'crosshair',
  cas: 'airplane',
  transport: 'truck',
  supplyDrop: 'box-seam',
  uav: 'broadcast',
  medevac: 'heart-pulse',
};

/** The supports a definition offers: those with a count above nought, in its own order. */
export function supportKeysOf(supports: Record<string, number> | undefined): string[] {
  return Object.entries(supports ?? {})
    .filter(([, n]) => Number(n) > 0)
    .map(([k]) => k);
}
